import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { STEP_ICON_WIDTH } from '@/components/Payment/PaymentInTerminals.constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
    margin-top: 5px;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 15px;
    gap: 10px;
  }
`;

export const PhoneLabel = styled(Typography.Body)`
  font-size: 16px;
  font-weight: 500;
  padding: 5px 0;
`;

export const PhoneBox = styled.div`
  padding: 10px 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const Phone = styled(Typography.Numbers)`
  text-align: center;
  background: ${({ theme }) => theme.palette.gradient.main};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    line-height: 19px;
    letter-spacing: 3px;
  }
`;

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.border};
  height: 0.5px;
`;

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas:
    'label label'
    'value valueBold';
  column-gap: 5px;
  row-gap: 15px;
`;
export const InfoLabel = styled(Typography.Body)`
  grid-area: label;
  font-size: 16px;
  font-weight: 500;
`;
export const InfoValue = styled(Typography.Body)`
  grid-area: value;
`;
export const InfoValueBold = styled(Typography.Header)`
  grid-area: valueBold;
  justify-self: end;
`;

export const Title = styled(Typography.Header)`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 10px;
  }
`;

export const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 10px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: calc(${STEP_ICON_WIDTH}px / 2 - 0.5px);
    width: 1px;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.primary.border};
  }
`;

export const Step = styled.div`
  display: grid;
  grid-template-columns: ${STEP_ICON_WIDTH}px 1fr;
  align-items: center;
  gap: 10px;
  position: relative;
`;

export const StepIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${STEP_ICON_WIDTH}px;
  height: ${STEP_ICON_WIDTH}px;
  border-radius: 50px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 14px;
  font-weight: 400;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const SubStep = styled(Step)`
  grid-column: 1/-1;
  margin-left: 40px;
`;

export const SubStepIcon = styled(StepIcon)`
  position: relative;

  img {
    width: 17px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -25px;
    width: 25px;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.primary.border};
  }
`;

export const EWallets = styled.div`
  display: grid;
  grid-template-columns: 35px 1fr;
  gap: 15px;
  justify-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
    justify-items: start;
    gap: 10px;
  }
`;

export const EWalletsText = styled.div`
  line-height: 20px;
  > * {
    display: inline;
  }
`;

export const Notifications = styled(Box)`
  gap: 10px;
`;

export const Notification = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const StepsAdditionalInfo = styled.div`
  padding-top: 15px;
  border-top: 0.5px solid ${({ theme }) => theme.palette.primary.border};
  max-width: 345px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 100%;
    padding-top: 20px;
  }
`;

export const ActionsContainer = styled.div`
  margin-top: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 0;
  }
`;
